// import React from 'react';
// import parse from 'html-react-parser';
import "./BannerSectionStyle5.scss";

// export default function BannerSectionStyle5({
//   bgUrl,
//   imgUrl,
//   title,
//   subTitle,
// }) {
//   return (
//     <section
//       className="cs_banner cs_style_5 cs_bg_filed"
//       style={{ backgroundImage: `url(${bgUrl})` }}
//     >
//       <div className="cs_banner_img">
//         <img src={imgUrl} alt="Banner" />
//       </div>
//       <div className="container">
//         <div className="cs_banner_text">
//           <h2 className="cs_banner_title cs_fs_72">{parse(title)}</h2>
//           <p className="cs_banner_subtitle cs_fs_20 mb-0 cs_heading_color">
//             {parse(subTitle)}
//           </p>
//         </div>
//       </div>
//     </section>
//   );
// }


const defaultTags = ["Epilepsy Care", "Stroke", "Pain Management"];


export default function BannerStyle5({
  bgUrl = "/images/about/banner_bg.jpg",
  imgUrl = "/images/about/banner_img.png",
  title = "Welcome to <em>Celbion</em> Healthcare",
  subTitle = "Our Products",
  tags = defaultTags,
  breadcrumbParent = "Home",
}) {
  return (
    <>
      <section className="cbs5">
        <div className="cbs5__bg" style={{ backgroundImage: `url(${bgUrl})` }} />
        <div className="cbs5__overlay" />
        <div className="cbs5__stripe" />
        <div className="cbs5__dotgrid" />

        {/* Floating product image */}
        <div className="cbs5__img-glow" />
        <div className="cbs5__img-wrap">
          <img src={imgUrl} alt="Banner" className="cbs5__img" />
        </div>

        <div className="cbs5__inner">
          {/* <div className="cbs5__breadcrumb">
            <span>{breadcrumbParent}</span>
            <span className="cbs5__breadcrumb-sep">/</span>
            <span className="cbs5__breadcrumb-current"
              dangerouslySetInnerHTML={{ __html: subTitle }}
            />
          </div> */}

          <h2
            className="cbs5__title"
            dangerouslySetInnerHTML={{ __html: title }}
          />

          <div className="cbs5__rule">
            <span className="cbs5__rule-line" />
            <span className="cbs5__rule-diamond" />
          </div>

          <p
            className="cbs5__sub"
            dangerouslySetInnerHTML={{ __html: subTitle }}
          />

          {tags?.length > 0 && (
            <div className="cbs5__tags">
              {tags.map((t) => (
                <span className="cbs5__tag" key={t}>
                  <span className="cbs5__tag-dot" />
                  {t}
                </span>
              ))}
            </div>
          )}
        </div>

        {/* Bottom wave SVG */}
        <svg className="cbs5__wave" viewBox="0 0 1440 60" preserveAspectRatio="none">
          <path
            d="M0,40 C360,70 1080,10 1440,40 L1440,60 L0,60 Z"
            fill="var(--cb5-ink,#04111f)"
            opacity=".5"
          />
        </svg>
      </section>
    </>
  );
}